module.exports = __webpack_public_path__ + "img/class_goalkeeper_A.f81d7dc9.jpg";